import React, { useEffect, useState } from 'react';
import { ApolloProvider } from 'react-apollo';
import { UserContextProvider, IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { URLContext, IUrl } from '@reverbdotcom/commons/src/url_context';
import { RoutingResult, RoutingResultContext } from '@reverbdotcom/commons/src/routing_result';
import { buildClient } from './lib/apollo_client';
import routerHistory, { initializeRouterHistory } from '@reverbdotcom/commons/src/cms/lib/router_history';

const RApolloProvider = ApolloProvider as any;

export interface IProps {
  user: IUser;
  client: ReturnType<typeof buildClient>;
  url: string;
  routingResult?: RoutingResult;
  referer: string;
  children?: React.ReactNode;
}

export default function AppProvider(props: IProps) {
  const urlFromCore = props.url;
  const pathname = new URL(urlFromCore).pathname;
  const [urlContextObject, setUrlContextObject] = useState<IUrl>(
    initializeRouterHistory(pathname).getCurrentLocation(),
  );

  useEffect(() => {
    routerHistory.listen(location => {
      setUrlContextObject(location);
    });
  }, []);

  return (
    <URLContext.Provider value={{ ...urlContextObject, referer: props.referer }}>
      <RoutingResultContext.Provider value={props.routingResult || {}}>
        <UserContextProvider user={props.user}>
          <RApolloProvider client={props.client}>
            {props.children}
          </RApolloProvider>
        </UserContextProvider>
      </RoutingResultContext.Provider>
    </URLContext.Provider>
  );
}
